export default function Grid3({
  color = '#878F9B',
  width = '20',
  height = '20',
}: {
  color?: string;
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.625 13.75H12.375C15.5 13.75 16.75 12.5 16.75 9.375V5.625C16.75 2.5 15.5 1.25 12.375 1.25H8.625C5.5 1.25 4.25 2.5 4.25 5.625V9.375C4.25 12.5 5.5 13.75 8.625 13.75Z'
        stroke={color}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M10.5 1.25V13.75'
        stroke={color}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M4.25 5.9375H10.5'
        stroke={color}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M10.5 9.0625H16.75'
        stroke={color}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
